import { SxProps } from '@mui/material';

export const styles: Record<string, SxProps> = {
  profileBox: {
    backgroundColor: 'common.white',
    width: '195px',
    height: '195px',
    border: '1.5px solid',
    borderColor: 'primary.light',
    borderRadius: '61px',
    m: '0 auto',
  },
};
